const API_BASE = 'https://connectapi.mosquepay.org/cmd_system_api/v1/api/'

module.exports = { API_BASE }
